<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" :toName="title" cneterName="合作伙伴" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="文字" prop="title">
          <a-input placeholder="请输入" v-model="ruleForm.title" style="max-width:500px" :maxLength="10"/>
        </a-form-model-item>

        <a-form-model-item label="链接" prop="linkAddress">
          <a-input v-model="ruleForm.linkAddress" :maxLength="400" placeholder="需以http://或https://开头"
                   style="max-width:500px"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'AddCooperativePartner',
  components: {
    Breadcrumb
  },
  mixins: [ruleFormMixins],
  data() {
    let handleContent = (rule, value, callback) => {
      if (value && (value.indexOf('http://') >= 0 || value.indexOf('https://') >= 0)) {
        callback()
      } else if (value) {
        callback(new Error('输入的链接不合法'))
      } else {
        callback(new Error('请输入链接'))
      }
    }
    return {
      ruleForm: {
        title: '',
        linkAddress: ''
      },
      rules: {
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        linkAddress: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: handleContent, trigger: 'blur' }
        ]
      },
      submitLoading: false,
      title: ''
    }
  },
  activated() {
    this.id = this.$route.query.id
    this.title = this.id ? '编辑友情链接' : '添加友情链接'
    this.goReset()
    if (this.id) {
      this.getDetails()
    }
  },
  methods: {
    getDetails() {
      let url = '/pc/v2/friendship-link/' + this.id
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.ruleForm.title = res.title
          this.ruleForm.linkAddress = res.linkAddress
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        title: this.ruleForm.title,
        linkAddress: this.ruleForm.linkAddress,
        id: this.id
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/friendship-link/save', parms).then(res => {
        this.$message.success('保存成功')
        this.submitLoading = false
        this.goBack()
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>